import React from 'react';

const toast = type => class extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { open: props.visible };
    }
    componentDidUpdate() { 
        this.setState({ open: this.props.visible }) 
        if (this.props.visible){
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.props.onClose, 3000)
        }
    }
    render() {
        const { children, onClose } = this.props;

        return <div className={`pc-toast pc-toast--${type} ${this.state.open ? 'pc-toast--show' : ''}`}>
            <div className="pc-toast__message">
            {this.state.open}
                {children}
            </div>
            <button className="pc-toast__close o-btn--icon" onClick={onClose}>
                <span className="pc-toast__close__icon"/>
            </button>
        </div>
    }
};


const Success = toast('success');
const Error = toast('error');

export { Success, Error }



// WEBPACK FOOTER //
// /src/components/shared/toast.js